{
  "familyId": "TOPO-WERELD-OCEANEN",
  "questions": [
    {
      "id": "TOPO-WERELD-OCEANEN-001",
      "familyId": "TOPO-WERELD-OCEANEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_oceanen_wereld",
      "questionType": "multiple_choice",
      "question": "Welke oceaan is de grootste ter wereld?",
      "options": ["De Stille Oceaan", "De Atlantische Oceaan", "De Indische Oceaan", "De Noordelijke IJszee"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De vijf oceanen",
            "content": "Van groot naar klein: 1) Stille Oceaan (grootste, tussen Azië en Amerika). 2) Atlantische Oceaan (tussen Europa/Afrika en Amerika). 3) Indische Oceaan (bij India/Australië). 4) Zuidelijke IJszee (rond Antarctica). 5) Noordelijke IJszee (rond Noordpool).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "oceanen_grootste",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Stille Oceaan (Pacific) is de grootste oceaan. Hij beslaat bijna een derde van het aardoppervlak en ligt tussen Azië/Australië en Noord-/Zuid-Amerika.",
        "solutionSteps": [
          "Stille Oceaan = grootste oceaan",
          "Bijna ⅓ van het aardoppervlak",
          "Tussen Azië en Amerika"
        ],
        "distractorExplanations": {
          "0": "Goed! De Stille Oceaan is de grootste oceaan ter wereld.",
          "1": "De Atlantische Oceaan is de op één na grootste, maar kleiner dan de Stille Oceaan.",
          "2": "De Indische Oceaan is de derde grootste oceaan.",
          "3": "De Noordelijke IJszee is de kleinste oceaan."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "topo.zee-vs-meer-verward", "optionIndex": 1, "label": "Atlantische Oceaan" },
          { "id": "topo.land-verkeerd-continent", "optionIndex": 2, "label": "Indische Oceaan" },
          { "id": "topo.klimaatzone-verward", "optionIndex": 3, "label": "Noordelijke IJszee" }
        ]
      }
    },
    {
      "id": "TOPO-WERELD-OCEANEN-002",
      "familyId": "TOPO-WERELD-OCEANEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_oceanen_wereld",
      "questionType": "multiple_choice",
      "question": "Welke oceaan ligt tussen Europa/Afrika en Amerika?",
      "options": ["De Atlantische Oceaan", "De Stille Oceaan", "De Indische Oceaan", "De Zuidelijke IJszee"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Atlantische Oceaan",
            "content": "De Atlantische Oceaan ligt tussen Europa/Afrika (oost) en Amerika (west). Columbus stak de Atlantische Oceaan over om Amerika te bereiken. Nederland ligt aan de Noordzee, die deel uitmaakt van de Atlantische Oceaan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "oceanen_atlantisch",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De Atlantische Oceaan ligt tussen Europa/Afrika aan de oostkant en Noord-/Zuid-Amerika aan de westkant. Het is de op één na grootste oceaan.",
        "solutionSteps": [
          "Atlantische Oceaan = tussen Europa/Afrika en Amerika",
          "Op één na grootste oceaan",
          "De Noordzee is een deel van de Atlantische Oceaan"
        ],
        "distractorExplanations": {
          "0": "Goed! De Atlantische Oceaan ligt tussen Europa/Afrika en Amerika.",
          "1": "De Stille Oceaan ligt aan de andere kant van Amerika, tussen Amerika en Azië.",
          "2": "De Indische Oceaan ligt bij India en Australië, niet bij Europa of Amerika.",
          "3": "De Zuidelijke IJszee ligt rond Antarctica, bij de Zuidpool."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "topo.zee-vs-meer-verward", "optionIndex": 1, "label": "Stille Oceaan" },
          { "id": "topo.land-verkeerd-continent", "optionIndex": 2, "label": "Indische Oceaan" },
          { "id": "topo.klimaatzone-verward", "optionIndex": 3, "label": "Zuidelijke IJszee" }
        ]
      }
    },
    {
      "id": "TOPO-WERELD-OCEANEN-003",
      "familyId": "TOPO-WERELD-OCEANEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_oceanen_wereld",
      "questionType": "multiple_choice",
      "question": "Hoeveel oceanen zijn er op aarde?",
      "options": ["5", "3", "4", "7"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vijf oceanen",
            "content": "Er zijn 5 oceanen: Stille Oceaan, Atlantische Oceaan, Indische Oceaan, Zuidelijke IJszee en Noordelijke IJszee. Samen bedekken ze ~71% van het aardoppervlak.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "oceanen_aantal",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Er zijn 5 oceanen: de Stille Oceaan, Atlantische Oceaan, Indische Oceaan, Zuidelijke IJszee en Noordelijke IJszee.",
        "solutionSteps": [
          "5 oceanen op aarde",
          "Stille, Atlantische, Indische Oceaan",
          "Zuidelijke en Noordelijke IJszee"
        ],
        "distractorExplanations": {
          "0": "Goed! Er zijn 5 oceanen.",
          "1": "3 is te weinig — je vergeet de twee ijszeeën.",
          "2": "4 is te weinig — je vergeet waarschijnlijk de Zuidelijke IJszee.",
          "3": "7 is het aantal continenten, niet oceanen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "topo.zee-vs-meer-verward", "optionIndex": 1, "label": "3 oceanen" },
          { "id": "topo.klimaatzone-verward", "optionIndex": 2, "label": "4 oceanen" },
          { "id": "topo.land-verkeerd-continent", "optionIndex": 3, "label": "7 oceanen" }
        ]
      }
    },
    {
      "id": "TOPO-WERELD-OCEANEN-004",
      "familyId": "TOPO-WERELD-OCEANEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_oceanen_wereld",
      "questionType": "multiple_choice",
      "question": "Welke oceaan ligt bij India, Oost-Afrika en Australië?",
      "options": ["De Indische Oceaan", "De Stille Oceaan", "De Atlantische Oceaan", "De Noordelijke IJszee"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Indische Oceaan",
            "content": "De Indische Oceaan ligt tussen Afrika (west), Azië/India (noord) en Australië (oost). Het is de derde grootste oceaan en het warmste water van alle oceanen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "oceanen_indisch",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De Indische Oceaan ligt tussen Afrika, Azië (India) en Australië. Het is de derde grootste oceaan. De naam komt van India.",
        "solutionSteps": [
          "Indische Oceaan = bij India, Afrika en Australië",
          "Derde grootste oceaan",
          "Naam komt van India"
        ],
        "distractorExplanations": {
          "0": "Goed! De Indische Oceaan ligt bij India, Oost-Afrika en Australië.",
          "1": "De Stille Oceaan ligt meer naar het oosten, bij Oost-Azië en Amerika.",
          "2": "De Atlantische Oceaan ligt bij West-Afrika en Amerika, niet bij India.",
          "3": "De Noordelijke IJszee ligt bij de Noordpool, ver van India."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "topo.zee-vs-meer-verward", "optionIndex": 1, "label": "Stille Oceaan" },
          { "id": "topo.gebergte-verkeerd-land", "optionIndex": 2, "label": "Atlantische Oceaan" },
          { "id": "topo.klimaatzone-verward", "optionIndex": 3, "label": "Noordelijke IJszee" }
        ]
      }
    },
    {
      "id": "TOPO-WERELD-OCEANEN-005",
      "familyId": "TOPO-WERELD-OCEANEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_oceanen_wereld",
      "questionType": "ordering",
      "question": "Zet de oceanen in volgorde van groot naar klein.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Stille Oceaan",
          "Atlantische Oceaan",
          "Indische Oceaan",
          "Zuidelijke IJszee",
          "Noordelijke IJszee"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oceanen op grootte",
            "content": "Van groot naar klein: 1) Stille Oceaan. 2) Atlantische Oceaan. 3) Indische Oceaan. 4) Zuidelijke IJszee. 5) Noordelijke IJszee.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "oceanen_grootte_ordering",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Van groot naar klein: Stille Oceaan → Atlantische Oceaan → Indische Oceaan → Zuidelijke IJszee → Noordelijke IJszee.",
        "solutionSteps": [
          "1. Stille Oceaan (grootste)",
          "2. Atlantische Oceaan",
          "3. Indische Oceaan",
          "4. Zuidelijke IJszee",
          "5. Noordelijke IJszee (kleinste)"
        ]
      }
    }
  ]
}